/*
 * @Author: your name
 * @Date: 2021-02-01 11:35:39
 * @LastEditTime: 2021-08-17 20:42:14
 * @LastEditors: hai.zhang
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-purchase\components\file-list\i18n.js
 */
export default {
  'zh-CN': {
    del: '删除',
    download: '下载',
    confirmDel: '确定移除{n}?',
    tips: '提示',
    confirm: '确定',
    cancel: '取消',
    delSuccess: '删除成功!'
  },
  'en': {
    del: 'Delete',
    download: 'Download',
    confirmDel: 'Confirm to remove {n}?',
    tips: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delSuccess: 'Delete success!'
  },
  'jp': {
  }
}
